module.exports = __webpack_public_path__ + "static/WEDDING E&M-337-dbb0f0f56720adc1ba5b175919a258c3.jpg";